// extracted by mini-css-extract-plugin
export default {"staffSlipForm":"staffSlipForm---TXtPw"};